import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { Skeleton } from './skeleton';

interface SkeletonTableColumn {
    index: number;
    width: string;
}

@Component({
    selector: 'qpx-skeleton-table',
    imports: [Skeleton],
    templateUrl: './skeleton-table.html',
    styleUrls: ['./skeleton-table.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.aria-label]': 'ariaLabel()',
        role: 'status',
        '[style.--qpx-skeleton-table-columns]': 'gridTemplateColumns()',
    },
})
export class SkeletonTable {
    //#region Inputs
    public readonly rows = input(6);
    public readonly columns = input(3);
    public readonly columnWidths = input<readonly string[]>([]);
    public readonly ariaLabel = input('Loading table');
    //#endregion

    //#region State
    protected readonly rowItems = computed(() =>
        Array.from(
            { length: this.toSafeCount(this.rows()) },
            (_, index) => index
        )
    );

    protected readonly columnItems = computed<SkeletonTableColumn[]>(() => {
        const columnCount = this.toSafeCount(this.columns());
        const columnWidths = this.columnWidths();

        return Array.from({ length: columnCount }, (_, index) => ({
            index,
            width: columnWidths[index] ?? '100%',
        }));
    });

    protected readonly gridTemplateColumns = computed(() => {
        const columnCount = this.toSafeCount(this.columns());

        return `repeat(${columnCount}, minmax(0, 1fr))`;
    });
    //#endregion

    //#region Private methods
    private toSafeCount(value: number): number {
        return Math.max(1, Math.floor(value));
    }
    //#endregion
}
